import { render } from "./InputVariables.vue?vue&type=template&id=68cf2323&scoped=true"
import script from "./InputVariables.vue?vue&type=script&lang=ts"
export * from "./InputVariables.vue?vue&type=script&lang=ts"

import "./InputVariables.vue?vue&type=style&index=0&id=68cf2323&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-68cf2323"

export default script